import Vue from 'vue';

Vue.component( 'input-archivo', () => import( '@com/inputs/input-archivo.vue' ) );
Vue.component( 'input-condicion-iva', () => import( '@com/inputs/input-condicion-iva.vue' ) );
Vue.component( 'input-cuit', () => import( '@com/inputs/input-cuit.vue' ) );
Vue.component( 'input-documento', () => import( '@com/inputs/input-documento.vue' ) );
Vue.component( 'input-email', () => import( '@com/inputs/input-email.vue' ) );
Vue.component( 'input-personas', () => import( '@com/inputs/input-personas.vue' ) );
Vue.component( 'input-tipo-envio', () => import( '@com/inputs/input-tipo-envio.vue' ) );